import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-lil flex flex-col align-items-center" }
const _hoisted_2 = { class: "flex-center flex-wrap" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text-sm text-grey-600 mt-1" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-4xl secondary-font text-grey-800 my-8" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "secondary-font text-5xl text-center mt-5 mb-7" }, [
        _createTextVNode(" Discuter avec "),
        _createElementVNode("br"),
        _createTextVNode("un conseiller client ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHAT_AGENTS, (agent) => {
          return (_openBlock(), _createElementBlock("div", {
            key: agent.name,
            class: "flex flex-col align-items-center mx-2 my-2"
          }, [
            _createElementVNode("img", {
              src: agent.avatar,
              class: "size-3xl rounded-100",
              alt: agent.name
            }, null, 8, _hoisted_3),
            _createElementVNode("span", _hoisted_4, _toDisplayString(agent.name), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("a", {
        href: `tel:${_ctx.phoneNumberClean}`
      }, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.phoneNumber), 1)
      ], 8, _hoisted_5),
      _createElementVNode("a", {
        href: `tel:${_ctx.phoneNumberClean}`
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("button", { class: "btn lg btn-chatbot flex-center px-10 gap-2" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-aide-appel.svg",
            class: "btn-icon",
            alt: ""
          }),
          _createElementVNode("span", null, "Appelez maintenant")
        ], -1)
      ]))], 8, _hoisted_7),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ])
  ]))
}